<template>
  <div class="containerrr w-full">
    <div class="upload-btn-wrapper items-center w-full" @click.prevent="uploadFile">
      <img class="upload-resume-icon" src="../../../../src/assets/images/icons/upload-resume.svg" />
      <button class="btn w-full" :class="{'upload-success': upload_success}">Drag’n drop or click to upload files</button>
      <input type="file" name="myfile" id="file" ref="file" @click.stop @change="submitFile" />
    </div>
  </div>
</template>

<script>
  export default {
    name: "UploadFile",
    data(){
      return {
        file: '',
        upload_success: false,
      }
    },
    methods: {
      submitFile(){
        this.file = this.$refs.file.files[0];
        this.$emit('uploadedfile', this.file);
        this.upload_success = true; 
      },
      uploadFile(){
        this.$refs.file.click();
      }
    }
  }
</script>

<style>
  .upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    cursor: pointer;
  }

  .btn {
    /*border: 2px solid gray;*/
    color: gray;
    /*background-color: white;*/
    padding: 120px 200px 80px 200px;
    /*border-radius: 8px;*/
    /*font-size: 20px;
    font-weight: bold;*/
    cursor: pointer;

    background: rgba(242, 147, 0, 0.06);
    border: 1px dashed #F29300;
    box-sizing: border-box;
    border-radius: 12px;

    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;

    color: #848199;
  }

  .upload-success {
    background-color: lightgreen! important;
  }

  .upload-btn-wrapper input[type=file] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }

  input {
    cursor: pointer! important;
  }

  .upload-resume-icon {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    margin-top: 40px;
  }
  @media (max-width: 1200px) {
    .btn {
      padding:120px 0px 80px 0px;;
    }
  }
</style>
